import { axiosWithKey } from "~/axios";
import { getToken } from "~/redux/user/tokens";
import { userLanguageSelector } from "~/tools/localization";

export const getClosedCaptions = (video) => {
    const enableCC = localStorage.getItem('closedCaption') !== "false";
    let finalCaptions = null;
    if(enableCC && video.contentDetails){
        finalCaptions = video.contentDetails.closedCaptions;
    }
    return finalCaptions;
}

export const enableAutoplay = () => {
    if(window.innerWidth < 768) {
        return false;
    } 
    return localStorage.getItem('autoplay') !== 'false';
}

export const getSiblingEpisodes = (season=null, episodeIdx) => {
    if(!season || !(episodeIdx >= 0)) return {prevEp:null, nextEp: null};
    const seasonLength = season.episodes.length;
    const prevEpIdx = episodeIdx - 1 >= 0 ? episodeIdx - 1 : seasonLength - 1;
    const nextEpIdx = ( episodeIdx + 1 ) % seasonLength;
    const prevEp = seasonLength > 1 ? season.episodes[prevEpIdx] : null;
    const nextEp = seasonLength > 1 ? season.episodes[nextEpIdx] : null;
    return { prevEp, nextEp, prevEpIdx, nextEpIdx };
}

export const getEpisodeIdx = (season=null, episodeId) => {
    let episodeIdx = null;
    if(!season) return null;
    season.episodes.forEach((episode, idx)=>{
        if(episode.gist.id === episodeId){
            episodeIdx = idx;
        }
    })
    return episodeIdx;
}

export const fetchSeriesData = async (seriesData = []) => {
    if(!seriesData || seriesData.length === 0) return [];
    const permalink = seriesData[0].gist.permalink;
    const { internalName } = window.settings;
    let seasons = [];
    const token = await getToken();
    const pageData = await axiosWithKey({
        method: "GET",
        url: `${window.settings.apiBaseUrlCached || window.settings.apiBaseUrl}/content/pages?site=${internalName}&path=${permalink}&languageCode=${userLanguageSelector()}&includeContent=true`,
        headers: { Authorization: token }
    });
    const seriesModule = pageData.data.modules.filter(e=>{
        return e.moduleType === 'ShowDetailModule' && e.contentData && e.contentData[0].gist.permalink === permalink;
    });
    if(seriesModule){
        seasons = seriesModule[0].contentData[0].seasons;
    }
    return seasons;
}

export const getSeasonIdx = (seasons, videoId) => {
    let seasonIdx = 0;
    for(let i = 0; i < seasons.length; i++){
        for(let j = 0; j < seasons[i].episodes.length; j++){
            if(seasons[i].episodes[j].id === videoId){
                seasonIdx = i;
                break;
            }
        }
    }
    return seasonIdx;
}